import { RegularExpressions } from "../../../../../../Helpers/RegularExpression";
import { ValForm, ValFormReg } from "../../../../../../Validators/ValForms";

export const ValPedidoDatosGenerales = (state) => {
  const correoelectronico = ValFormReg(
    "Correo electronico",
    state.correoelectronico,
    RegularExpressions.TextEmail
  );
  const celular = ValFormReg(
    "Celular",
    state.celular,
    RegularExpressions.TextOnlyNumber,
    10,
    10
  );
  const domicilio = ValFormReg(
    "Domicilio",
    state.domicilio,
    RegularExpressions.TextSpecialCharacter
  );
  const fechaentrega = ValForm("Fecha entrega", state.fechaentrega);
  const lugardeentrega = ValFormReg(
    "Lugar de entrega",
    state.lugarentrega,
    RegularExpressions.TextSpecialCharacter
  );
  const condiciones = ValFormReg(
    "Condiciones de crédito",
    state.condiciones,
    RegularExpressions.TextSpecialCharacter
  );
  const metodopago = ValFormReg(
    "Metodo de pago",
    state.metodopago,
    RegularExpressions.TextAndNumber
  );
  const formapago = ValFormReg(
    "Forma de pago",
    state.formapago,
    RegularExpressions.TextAndNumber
  );
  const usocfdi = ValFormReg(
    "Uso de CFDI",
    state.usocfdi,
    RegularExpressions.TextAndNumber
  );
  const tiporelacion = ValFormReg(
    "Tipo de relación",
    state.tiporelacion,
    RegularExpressions.TextAndNumber
  );
  const anticipos = ValForm(
    "Anticipos",
    state.anticipos,
    RegularExpressions.TextWithSpace
  );
  const folioanticipo = ValForm(
    "Folios de Anticipos",
    state.folioanticipo,
    RegularExpressions.TextWithSpace
  );
  var isValid = true;
  var mensaje = "";
  if (correoelectronico.isValid === false) {
    state.bcorreoelectronico = true;
    state.mcorreoelectronico = correoelectronico.mensaje;
    isValid = false;
    mensaje += correoelectronico.mensaje;
  }
  if (celular.isValid === false) {
    state.bcelular = true;
    state.mcelular = celular.mensaje;
    isValid = false;
    mensaje += celular.mensaje;
  }
  if (fechaentrega.isValid === false) {
    state.bfechaentrega = true;
    state.mfechaentrega = fechaentrega.mensaje;
    isValid = false;
    mensaje += fechaentrega.mensaje;
  }
  if (domicilio.isValid === false) {
    state.bdomicilio = true;
    state.mdomicilio = domicilio.mensaje;
    isValid = false;
    mensaje += domicilio.mensaje;
  }
  if (lugardeentrega.isValid === false) {
    state.blugarentrega = true;
    state.mlugarentrega = lugardeentrega.mensaje;
    isValid = false;
    mensaje += lugardeentrega.mensaje;
  }
  if (condiciones.isValid === false) {
    state.bcondiciones = true;
    state.mcondiciones = condiciones.mensaje;
    isValid = false;
    mensaje += condiciones.mensaje;
  }
  if (metodopago.isValid === false) {
    state.bmetodopago = true;
    state.mmetodopago = metodopago.mensaje;
    isValid = false;
    mensaje += metodopago.mensaje;
  }
  if (formapago.isValid === false) {
    state.bformapago = true;
    state.mformapago = formapago.mensaje;
    isValid = false;
    mensaje += formapago.mensaje;
  }
  if (usocfdi.isValid === false) {
    state.busocfdi = true;
    state.musocfdi = usocfdi.mensaje;
    isValid = false;
    mensaje += usocfdi.mensaje;
  }
  if (tiporelacion.isValid === false) {
    state.btiporelacion = true;
    state.mtiporelacion = tiporelacion.mensaje;
    isValid = false;
    mensaje += tiporelacion.mensaje;
  }

  if (state.anticipos === "SI") {
    const folioanticipos = ValFormReg(
      "FOLIOS DE ANTICIPOS",
      state.folioanticipo,
      RegularExpressions.TextSpecialCharacter
    );
    if (folioanticipos.isValid === false) {
      state.bfolioanticipo = true;
      state.folioanticipo = tiporelacion.mensaje;
      isValid = false;
      mensaje += folioanticipo.mensaje;
    }
  }

  if (isValid === false) {
    return { isValid, state, mensaje };
  } else {
    return {
      isValid,
      post: {
        folio: "",
        celular: state.celular,
        correoelectronico: state.correoelectronico,
        fechaentrega: state.fechaentrega,
        domicilio: state.domicilio,
        lugarentrega: state.lugarentrega,
        condicionescredito: state.condiciones,
        metodopago: state.metodopago,
        formapago: state.formapago,
        usocfdi: state.usocfdi,
        tiporelacion: state.tiporelacion,
        nombre_aval:"",
        direccion_aval:"",
        anticipos:
          state.anticipos === undefined || state.anticipos === null
            ? ""
            : state.anticipos,
        foliosanticipos:
          state.folioanticipo === undefined || state.folioanticipo === null
            ? ""
            : state.folioanticipo,
      },
    };
  }
};
